/* eslint-disable import/no-cycle */
import React from 'react';
import { IoMdClose } from 'react-icons/io';
import { RiErrorWarningFill } from 'react-icons/ri';

import OutlinedButton from 'components/layout/form/outlinedButton';
import ContainedButton from 'components/layout/form/containedButton';

import {
  Content,
  Footer,
  Header,
  TitleContent,
  SubtitleContent,
} from './styles';

interface IProps {
  onClickSuccess: () => Promise<void>;
  onClickFail: () => void;
  loading: boolean;
}

const ModalContentConfirm = ({
  onClickSuccess,
  onClickFail,
  loading,
}: IProps): JSX.Element => {
  return (
    <>
      <Header>
        <IoMdClose onClick={onClickFail} />
      </Header>
      <Content>
        <RiErrorWarningFill />
        <TitleContent>Tem certeza que deseja Salvar?</TitleContent>
        <SubtitleContent>
          {`Lembrando que só poderá alterar novamente daqui a `}
          <span>3 meses</span>
        </SubtitleContent>
      </Content>
      <Footer>
        <OutlinedButton onClick={onClickFail} disabled={loading}>
          Não, cancelar
        </OutlinedButton>
        <ContainedButton
          onClick={onClickSuccess}
          disabled={loading}
          loading={loading}
        >
          Sim, Salvar!
        </ContainedButton>
      </Footer>
    </>
  );
};

export default ModalContentConfirm;
